/**
 * @generated SignedSource<<6a1804dec0f11f28fd35e2cbcfe5f9f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleAuthorDetailsContent$data = {
  readonly authors: ReadonlyArray<{
    readonly bio: string | null | undefined;
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorCardAuthor">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleAuthorDetailsContent";
};
export type articleAuthorDetailsContent$key = {
  readonly " $data"?: articleAuthorDetailsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleAuthorDetailsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleAuthorDetailsContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bio",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorCardAuthor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "6b5a458957768e3d93fe390c423df4fd";

export default node;
